import { getLogsForCalendarDay, sortEmployeeDayLogs } from "./employeeDayEffectiveMinutes"

const timeToMinutes = (vreme) => {
    if (!vreme || typeof vreme !== "string") return 0
    const [h, m] = vreme.split(":").map(Number)
    if (Number.isNaN(h)) return 0
    return h * 60 + (Number.isNaN(m) ? 0 : m)
}

const logToDate = (log) => {
    const y = Number(log.godina)
    const mo = Number(log.mesec) - 1
    const d = Number(log.dan)
    const mins = timeToMinutes(log.vreme)
    const dt = new Date(y, mo, d, 0, 0, 0, 0)
    dt.setMinutes(mins)
    return dt
}

export const monthHasThirdShiftLogs = (logsByDay) => {
    if (!logsByDay || typeof logsByDay !== "object") return false
    for (const key of Object.keys(logsByDay)) {
        const arr = logsByDay[key]
        if (Array.isArray(arr) && arr.some((l) => l.treca_smena === true)) return true
    }
    return false
}

export const hoursSinceFiveAmOnAnchor = (anchorYear, anchorMonth1to12, anchorDay, when) => {
    const anchor = new Date(anchorYear, anchorMonth1to12 - 1, anchorDay, 5, 0, 0, 0)
    return (when.getTime() - anchor.getTime()) / (3600 * 1000)
}

export const hoursSinceMidnightOnAnchor = (anchorYear, anchorMonth1to12, anchorDay, when) => {
    const anchor = new Date(anchorYear, anchorMonth1to12 - 1, anchorDay, 0, 0, 0, 0)
    return (when.getTime() - anchor.getTime()) / (3600 * 1000)
}

const clampChartY = (y) => (Number.isFinite(y) ? Math.min(24, Math.max(0, y)) : null)

const logToChartY = (log, hoursOnAnchor) => {
    const at = logToDate(log)
    return clampChartY(
        hoursOnAnchor(Number(log.godina), Number(log.mesec), Number(log.dan), at)
    )
}

const pickDayChartLogs = (dayLogs) => {
    const sorted = sortEmployeeDayLogs(dayLogs)
    const thirdIdx = sorted.findIndex((l) => l.status === "ulaz" && l.treca_smena === true)

    if (thirdIdx === -1) {
        const regularEntry = sorted.find((l) => l.status === "ulaz") ?? null
        const izlazi = sorted.filter((l) => l.status === "izlaz")
        const regularExit = izlazi.length ? izlazi[izlazi.length - 1] : null
        return { regularEntry, regularExit, thirdEntry: null, thirdExit: null }
    }

    const beforeThird = sorted.slice(0, thirdIdx)
    const thirdEntry = sorted[thirdIdx]
    const afterThird = sorted.slice(thirdIdx + 1)

    const regularEntry = beforeThird.find((l) => l.status === "ulaz" && l.treca_smena !== true) ?? null
    const izlaziBefore = beforeThird.filter((l) => l.status === "izlaz" && l.treca_smena !== true)
    const regularExit = izlaziBefore.length ? izlaziBefore[izlaziBefore.length - 1] : null

    const izlaziThird = afterThird.filter((l) => l.status === "izlaz" && l.treca_smena === true)
    const thirdExit = izlaziThird.length ? izlaziThird[izlaziThird.length - 1] : null

    return { regularEntry, regularExit, thirdEntry, thirdExit }
}

const emptyRow = (day) => ({
    day,
    arrivalY: null,
    exitY: null,
    arrivalThirdY: null,
    exitThirdY: null
})

export const buildEmployeeMonthChartSeries = (logsByDay, year, monthIndex0) => {
    const daysInMonth = new Date(year, monthIndex0 + 1, 0).getDate()

    if (!logsByDay || typeof logsByDay !== "object") {
        return Array.from({ length: daysInMonth }, (_, i) => emptyRow(i + 1))
    }

    const useMidnightAxis = monthHasThirdShiftLogs(logsByDay)
    const hoursOnAnchor = useMidnightAxis ? hoursSinceMidnightOnAnchor : hoursSinceFiveAmOnAnchor
    const rows = []

    for (let day = 1; day <= daysInMonth; day++) {
        const dLogs = getLogsForCalendarDay(logsByDay, year, monthIndex0, day)
        if (!dLogs.length) {
            rows.push(emptyRow(day))
            continue
        }

        const { regularEntry, regularExit, thirdEntry, thirdExit } = pickDayChartLogs(dLogs)
        const toY = (log) => (log ? logToChartY(log, hoursOnAnchor) : null)

        rows.push({
            day,
            arrivalY: toY(regularEntry),
            exitY: toY(regularExit),
            arrivalThirdY: toY(thirdEntry),
            exitThirdY: toY(thirdExit)
        })
    }

    return rows
}

const hasFiniteY = (v) => v != null && Number.isFinite(v)

export const buildGapSegments = (rows, key) => {
    if (!rows?.length) return []
    const active = rows.filter((r) => hasFiniteY(r[key])).sort((a, b) => a.day - b.day)
    const segs = []
    for (let p = 0; p < active.length - 1; p++) {
        const da = active[p].day
        const db = active[p + 1].day
        if (db - da <= 1) continue
        segs.push({
            dayA: da,
            yA: active[p][key],
            dayB: db,
            yB: active[p + 1][key]
        })
    }
    return segs
}
